import { render, staticRenderFns } from "./partner-contribution-selection.vue?vue&type=template&id=4948a90c&"
import script from "./partner-contribution-selection.vue?vue&type=script&lang=ts&"
export * from "./partner-contribution-selection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports